import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import "./index.css";
import Container from "../General/Container";
import NpMobileLogo from "../../assets/images/logo/NpLogoMobile.svg";
import { headerTitleJSON } from "../constants";
import Strip from "../Strip";
import ConnectWithUsModal from "../General/ConnectWithUsModal";
import MobileNav from "./MobileNav";
import CloseIcon from "../../assets/images/icons/CloseIcon.png";
import HamburgerMenu from "../../assets/images/icons/HamburgerMenu.png";

function Header() {
  const [modalOpen, setModalOpen] = useState(false);
  const [isNavOpen, setIsNavOpen] = useState(false);
  const [variant, setVariant] = useState("form");
  const [strip, setStrip] = useState(true);

  const location = useLocation();

  const headerTitle = headerTitleJSON.find(({ url }) => url === location.pathname);

  useEffect(() => {
    // The MetalCloud page sets its own title through Helmet. Its entry in
    // headerTitleJSON has an object for `text`, which would stringify to
    // "[object Object]" here and overwrite the Helmet title.
    if (location.pathname === "/metalcloud") return;

    if (headerTitle?.text) {
      document.title = "NowPurchase || " + headerTitle.text;
    } else {
      document.title = "NowPurchase || Home";
    }
  }, [headerTitle, location.pathname]);

  useEffect(() => {
    const handleScroll = () => {
      setStrip(window.scrollY === 0);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      <ConnectWithUsModal modalOpen={modalOpen} setModalOpen={setModalOpen} variant={variant} />
      {/* {strip && <Strip />} */}

      <div className="headerNew" style={{ top: 0 }}>
        <Container>
          <div className="headerWrapper">
            <div className="logoWrapper">
              <Link className="logoMain" to="/">
                <img src={NpMobileLogo} loading="lazy" alt="logo" />
              </Link>

              {headerTitle?.text && <div className="pageTitleNew">{headerTitle.text}</div>}
            </div>

            <nav className="navigationWrapper">
              <ul>
                <li>
                  <Link to="/marketplace" id="Header_Services_Marketplace">
                    MarketPlace
                  </Link>
                </li>
                <li>
                  <Link to="/metalcloud" id="Header_Services_MetalCloud">
                    MetalCloud
                  </Link>
                </li>
                <li>
                  <Link to="/scrap-recycling" id="Header_Services_Scrap">
                    Scrap Recycling
                  </Link>
                </li>

                <li className="seperator">|</li>

                <li>
                  <Link to="/culture" className="culture">
                    Culture
                  </Link>
                </li>

                <li className="seperator">|</li>

                <li>
                  <button className="hiringBtnText">
                    <Link to="/careers" className="careers">
                      Careers
                    </Link>
                  </button>
                </li>
              </ul>
            </nav>

            {isNavOpen && <MobileNav setModalOpen={setModalOpen} setIsNavOpen={setIsNavOpen} />}

            <div className="menuWrapper">
              <button onClick={() => {
                      setVariant("form");   
                      setModalOpen(true);
                    }}
              className="getInTouchBtn">
                Get In Touch
              </button>

              <div className="hamburgerMenu" onClick={() => setIsNavOpen(!isNavOpen)}>
                <img src={isNavOpen ? CloseIcon : HamburgerMenu} alt="menu" />
              </div>
            </div>
          </div>
        </Container>
      </div>
    </>
  );
}

export default Header;
